import { h, Component } from 'preact';
import { Banner } from 'lib/mkjs';
import { contactInfoIsEmpty } from '../contactview';

export class WelcomeMessage extends Component {
	render() {
		if (this.props.contactEntity) {
			if (this.props.contactEntity.contactInfo && contactInfoIsEmpty(this.props.contactEntity.contactInfo)) {
				return <div class="mb-4">
					<Banner fullWidth>
						<h4>Welcome to Addy!</h4>
						<div>Get started by <a href="/me?edit">adding your contact info</a>.</div>
					</Banner>
				</div>
			}
		}
	}
}



// WEBPACK FOOTER //
// ./components/elements/welcomemessage/index.js